const enMessages = {
  dropdowns: {
      nodata: 'DATA NOT FOUND',
      clear: 'clear',
      comboArrowBtnAriaLabelExpand: 'expand combo box',
      comboArrowBtnAriaLabelCollapse: 'collapse combo box',
      dropDownListArrowBtnAriaLabel: 'choose'
  }
};

export default enMessages;